import React from 'react';
import { intl } from 'ehs-react';

import { getPageLogoUrl } from 'ehs-react';

export function PublicHeader(): JSX.Element {
  return (
    <div className="vvpp-public-header">
      <div className="vvpp-public-header-logo">
        <img src={getPageLogoUrl()} alt="logo" />
      </div>
      <div className="vvpp-public-header-name">
        {intl('virtualvisitpatientportlet.title')}
      </div>
      <div className="vvpp-public-header-placeholder" />
    </div>
  );
}
